var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewsTypes'),_c('MobileList',{attrs:{"typeId":_vm.newsType}}),_c('WebList',{attrs:{"typeId":_vm.newsType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }